import { Link } from "react-router-dom";

export function SupportPage() {
  return (
    <article className="standard-page legal-page">
      <header className="page-heading">
        <p className="eyebrow">My K-List Support</p>
        <h1>How can we help?</h1>
        <p>Questions, account help, catalog corrections, and safety concerns are welcome.</p>
      </header>
      <div className="legal-document">
        <section>
          <h2>Contact</h2>
          <p>Email <a href="mailto:support@djdev.me">support@djdev.me</a>. Include your username and app version when it helps; never send an Apple or Google password.</p>
        </section>
        <section>
          <h2>Safety reports</h2>
          <p>Use Report or Block from a person or public list whenever possible. For urgent follow-up, email <a href="mailto:safety@djdev.me">safety@djdev.me</a>.</p>
        </section>
        <section>
          <h2>Your data</h2>
          <p>Export your library from Settings. Permanently delete your account and synced data from Profile in the iPhone app or on the web.</p>
        </section>
      </div>
      <nav className="legal-nav" aria-label="Support links">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Use</Link>
        <Link to="/">Return to My K-List</Link>
      </nav>
    </article>
  );
}
